import React from "react";
import type { DocumentElement as DocumentElementType } from "@eaco/forms-core";

import { Separator } from "../ui/separator";
import HiddenElementBanner from "./HiddenElementBanner";
import ArchivedElementBanner from "./ArchivedElementBanner";

interface Props {
  element: DocumentElementType;
}

const Divider: React.FC<Props> = ({ element }) => {
  const data = element.data as {
    hidden?: boolean;
  };

  return (
    <div className="space-y-2">
      <Separator className="my-2" />
      <HiddenElementBanner hidden={data?.hidden} />
      <ArchivedElementBanner archived={element.archived} />
    </div>
  );
};

export default Divider;
